import React, { useState, useEffect, useMemo, useRef } from 'react';

const nombreCliente = c =>
  c.nombre_completo || [c.nombres, c.apellido_paterno, c.apellido_materno].filter(Boolean).join(' ');

/**
 * Filtro de cliente como campo de texto con sugerencias en vivo (mismo
 * espíritu que el buscador de Clientes), en vez de un <select> con todos
 * los clientes listados. `value` es el client_id seleccionado (o '' para
 * "Todos los clientes"); `onChange(id)` se llama al elegir uno o al borrar
 * el texto (onChange('')).
 */
export default function ClienteFiltroCombo({ clients, value, onChange, placeholder = 'Todos los clientes' }) {
  const [text, setText] = useState('');
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!value) { setText(''); return; }
    const c = clients.find(cl => String(cl.id) === String(value));
    if (c) setText(nombreCliente(c));
  }, [value, clients]);

  useEffect(() => {
    const onDocClick = e => { if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false); };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, []);

  const matches = useMemo(() => {
    if (!text) return [];
    const s = text.toUpperCase();
    return clients
      .filter(c => nombreCliente(c).toUpperCase().includes(s) || (c.document_number || '').includes(text))
      .slice(0, 30);
  }, [text, clients]);

  return (
    <div ref={wrapRef} className="cli-combo-wrap">
      <input
        className="si-select"
        placeholder={placeholder}
        value={text}
        onChange={e => {
          setText(e.target.value);
          setOpen(true);
          if (!e.target.value) onChange('');
        }}
        onFocus={() => setOpen(true)}
      />
      {open && text && (
        <div className="cli-combo-drop">
          {matches.length === 0 ? (
            <div className="cli-combo-empty">Sin coincidencias</div>
          ) : matches.map(c => (
            <div
              key={c.id}
              className="cli-combo-opt"
              onClick={() => { onChange(c.id); setText(nombreCliente(c)); setOpen(false); }}
            >
              {nombreCliente(c)}
              {c.document_number && <span className="cli-combo-doc"> · {c.document_number}</span>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
